import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _hoisted_1 = { class: "root" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "root__background" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "root__stripes" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo",
  class: "root__logo"
}, null, -1)

import { computed, provide, ref } from "vue";
import DataStorage from "@/utils/data-storage";
import MainLoader from "@/components/MainLoader.vue";
import StartScreen from "@/components/StartScreen.vue";
import SelectScreen from "@/components/SelectScreen.vue";
import EpochProgress from "@/components/EpochProgress.vue";
import PhotoScreen from "@/components/PhotoScreen.vue";
import ResultScreen from "@/components/ResultScreen.vue";
import { AppState } from "@/types/AppState";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

_useCssVars(_ctx => ({
  "5c19cdba": (desktopImg.value),
  "2f73902a": (stripes.value)
}))

const currentIndex = ref(0);

const selectedGender = ref<"male" | "female">("male");
const selectedEpoch = ref<60 | 70 | 80>(60);

const onGenderSelect = (data: "male" | "female") => {
  selectedGender.value = data;
  appState.value = AppState.CHOOSE_EPOCH;
};

const onEpochSelected = (data: 60 | 70 | 80) => {
  selectedEpoch.value = data;
  appState.value = AppState.PHOTO;
};

const resultData = ref<{
  title: string;
  result_text: string;
  result_url: string;
  uuid: string;
}>({
  title: "",
  result_text: "",
  result_url: "",
  uuid: "",
});

const onShowResult = (data: {
  title: string;
  result_text: string;
  result_url: string;
  uuid: string;
}) => {
  resultData.value = data;
  appState.value = AppState.RESULT;
};

const defaultUuid = ref("");

const appState = ref<AppState>(AppState.LOADING);

if (window.location.pathname.includes("result")) {
  const els = window.location.pathname.split("/");
  currentIndex.value = 1;
  defaultUuid.value = els[els.length - 1];
}

const newDataStorage = new DataStorage();
const isLoading = ref(true);
const data = ref({});
const mainAssets = ref({});
const progress = ref(0);

newDataStorage.loadMainAssets().then(() => {
  mainAssets.value = newDataStorage.mainAssets;
  newDataStorage.load((p, isFinished) => {
    progress.value = p;

    if (isFinished) {
      isLoading.value = false;
      data.value = newDataStorage.loadedAssets;

      appState.value = defaultUuid.value ? AppState.PHOTO : AppState.START;
    }
  });
});

provide("data", data);

const onBeforeEnter = () => {
  document.body.style.overflow = "hidden";
};
const onAfterLeave = () => {
  document.body.style.overflow = "auto";
};

const desktopImg = computed(() => {
  return `url(${mainAssets.value.desktop})`;
});

const stripes = computed(() => {
  return `url(${mainAssets.value.stripes})`;
});

const resetData = () => {
  defaultUuid.value = "";
  appState.value = AppState.START;
  resultData.value = {
    title: "",
    result_url: "",
    result_text: "",
    uuid: "",
  };
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_Transition, {
      name: "fade",
      onBeforeEnter: onBeforeEnter,
      onAfterLeave: onAfterLeave
    }, {
      default: _withCtx(() => [
        (appState.value === _unref(AppState).LOADING)
          ? (_openBlock(), _createBlock(MainLoader, {
              key: 0,
              progress: progress.value
            }, null, 8, ["progress"]))
          : (appState.value === _unref(AppState).START)
            ? (_openBlock(), _createBlock(StartScreen, {
                key: 1,
                onSelectGender: onGenderSelect
              }))
            : (appState.value === _unref(AppState).CHOOSE_EPOCH)
              ? (_openBlock(), _createBlock(SelectScreen, {
                  key: 2,
                  onSelect: onEpochSelected
                }))
              : (appState.value === _unref(AppState).PHOTO)
                ? (_openBlock(), _createBlock(PhotoScreen, {
                    key: 3,
                    "selected-epoch": selectedEpoch.value,
                    "selected-gender": selectedGender.value,
                    "default-uuid": defaultUuid.value,
                    onShowResult: onShowResult
                  }, null, 8, ["selected-epoch", "selected-gender", "default-uuid"]))
                : (appState.value === _unref(AppState).RESULT)
                  ? (_openBlock(), _createBlock(ResultScreen, _mergeProps({ key: 4 }, resultData.value, { onRepeat: resetData }), null, 16))
                  : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _hoisted_3,
    _hoisted_4,
    (appState.value !== _unref(AppState).LOADING && appState.value !== _unref(AppState).START)
      ? (_openBlock(), _createBlock(EpochProgress, {
          key: 0,
          state: appState.value
        }, null, 8, ["state"]))
      : _createCommentVNode("", true)
  ]))
}
}

})